import { defineMessages } from 'react-intl';

export default defineMessages({
  helpPageTitle: {
    id: 'app.help.title',
    defaultMessage: 'How can we help?',
  },
  helpPageFaqTitle: {
    id: 'app.help.faq.title',
    defaultMessage: 'Browse our FAQs',
  },
  helpPageFaqDescription: {
    id: 'app.help.faq.description',
    defaultMessage: 'Get answers to common questions.',
  },
  helpPageFaqButton: {
    id: 'app.help.faq.button',
    defaultMessage: 'View FAQs',
  },
  helpPageContactTitle: {
    id: 'app.help.contact.title',
    defaultMessage: 'Need to speak to us?',
  },
  helpPageContactDefault: {
    id: 'app.help.contact.default',
    defaultMessage: 'Get in touch:',
  },
  helpPageContactAccountManager: {
    id: 'app.help.contact.manager',
    defaultMessage: 'Drop us a line:',
  },
  helpPageContactAdmin: {
    id: 'app.help.contact.admin',
    defaultMessage: 'Just contact your admin:',
  },
  helpPageContactCustomerService: {
    id: 'app.help.contact.cs',
    defaultMessage: 'Get in touch:',
  },
  helpPagePopUpError: {
    id: 'app.help.faq.error',
    defaultMessage: 'Hmm. Our FAQs are having trouble loading. Try later (or get in touch!)',
  },
});
